"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M10.625 1.875C10.625 2.22018 10.3452 2.5 10 2.5C9.65482 2.5 9.375 2.22018 9.375 1.875C9.375 1.52982 9.65482 1.25 10 1.25C10.3452 1.25 10.625 1.52982 10.625 1.875Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.1875C10.1726 2.1875 10.3125 2.04759 10.3125 1.875C10.3125 1.70241 10.1726 1.5625 10 1.5625C9.82741 1.5625 9.6875 1.70241 9.6875 1.875C9.6875 2.04759 9.82741 2.1875 10 2.1875ZM10 2.5C10.3452 2.5 10.625 2.22018 10.625 1.875C10.625 1.52982 10.3452 1.25 10 1.25C9.65482 1.25 9.375 1.52982 9.375 1.875C9.375 2.22018 9.65482 2.5 10 2.5Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2967 12.6352L3.04671 6.12207L3.20329 5.85162L14.4533 12.3648L14.2967 12.6352Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7967 5.85162L5.54671 12.3648L5.70329 12.6352L16.9533 6.12206L16.7967 5.85162Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1727 18.0964L10.1563 4.99963L9.84375 5L9.86018 18.0967L10.1727 18.0964Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    d: "M10.9375 10C10.9375 10.5178 10.5178 10.9375 10 10.9375C9.48223 10.9375 9.0625 10.5178 9.0625 10C9.0625 9.48223 9.48223 9.0625 10 9.0625C10.5178 9.0625 10.9375 9.48223 10.9375 10Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.625C10.3452 10.625 10.625 10.3452 10.625 10C10.625 9.65482 10.3452 9.375 10 9.375C9.65482 9.375 9.375 9.65482 9.375 10C9.375 10.3452 9.65482 10.625 10 10.625ZM10 10.9375C10.5178 10.9375 10.9375 10.5178 10.9375 10C10.9375 9.48223 10.5178 9.0625 10 9.0625C9.48223 9.0625 9.0625 9.48223 9.0625 10C9.0625 10.5178 9.48223 10.9375 10 10.9375Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    d: "M3.75 5.9375C3.75 6.28268 3.47018 6.5625 3.125 6.5625C2.77982 6.5625 2.5 6.28268 2.5 5.9375C2.5 5.59232 2.77982 5.3125 3.125 5.3125C3.47018 5.3125 3.75 5.59232 3.75 5.9375Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 6.25C3.29759 6.25 3.4375 6.11009 3.4375 5.9375C3.4375 5.76491 3.29759 5.625 3.125 5.625C2.95241 5.625 2.8125 5.76491 2.8125 5.9375C2.8125 6.11009 2.95241 6.25 3.125 6.25ZM3.125 6.5625C3.47018 6.5625 3.75 6.28268 3.75 5.9375C3.75 5.59232 3.47018 5.3125 3.125 5.3125C2.77982 5.3125 2.5 5.59232 2.5 5.9375C2.5 6.28268 2.77982 6.5625 3.125 6.5625Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    d: "M17.5 5.9375C17.5 6.28268 17.2202 6.5625 16.875 6.5625C16.5298 6.5625 16.25 6.28268 16.25 5.9375C16.25 5.59232 16.5298 5.3125 16.875 5.3125C17.2202 5.3125 17.5 5.59232 17.5 5.9375Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.875 6.25C17.0476 6.25 17.1875 6.11009 17.1875 5.9375C17.1875 5.76491 17.0476 5.625 16.875 5.625C16.7024 5.625 16.5625 5.76491 16.5625 5.9375C16.5625 6.11009 16.7024 6.25 16.875 6.25ZM16.875 6.5625C17.2202 6.5625 17.5 6.28268 17.5 5.9375C17.5 5.59232 17.2202 5.3125 16.875 5.3125C16.5298 5.3125 16.25 5.59232 16.25 5.9375C16.25 6.28268 16.5298 6.5625 16.875 6.5625Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    d: "M10.625 5C10.625 5.34518 10.3452 5.625 10 5.625C9.65482 5.625 9.375 5.34518 9.375 5C9.375 4.65482 9.65482 4.375 10 4.375C10.3452 4.375 10.625 4.65482 10.625 5Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.3125C10.1726 5.3125 10.3125 5.17259 10.3125 5C10.3125 4.82741 10.1726 4.6875 10 4.6875C9.82741 4.6875 9.6875 4.82741 9.6875 5C9.6875 5.17259 9.82741 5.3125 10 5.3125ZM10 5.625C10.3452 5.625 10.625 5.34518 10.625 5C10.625 4.65482 10.3452 4.375 10 4.375C9.65482 4.375 9.375 4.65482 9.375 5C9.375 5.34518 9.65482 5.625 10 5.625Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    d: "M3.75 14.0625C3.75 14.4077 3.47018 14.6875 3.125 14.6875C2.77982 14.6875 2.5 14.4077 2.5 14.0625C2.5 13.7173 2.77982 13.4375 3.125 13.4375C3.47018 13.4375 3.75 13.7173 3.75 14.0625Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.125 14.375C3.29759 14.375 3.4375 14.2351 3.4375 14.0625C3.4375 13.8899 3.29759 13.75 3.125 13.75C2.95241 13.75 2.8125 13.8899 2.8125 14.0625C2.8125 14.2351 2.95241 14.375 3.125 14.375ZM3.125 14.6875C3.47018 14.6875 3.75 14.4077 3.75 14.0625C3.75 13.7173 3.47018 13.4375 3.125 13.4375C2.77982 13.4375 2.5 13.7173 2.5 14.0625C2.5 14.4077 2.77982 14.6875 3.125 14.6875Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    d: "M17.5 14.0625C17.5 14.4077 17.2202 14.6875 16.875 14.6875C16.5298 14.6875 16.25 14.4077 16.25 14.0625C16.25 13.7173 16.5298 13.4375 16.875 13.4375C17.2202 13.4375 17.5 13.7173 17.5 14.0625Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.875 14.375C17.0476 14.375 17.1875 14.2351 17.1875 14.0625C17.1875 13.8899 17.0476 13.75 16.875 13.75C16.7024 13.75 16.5625 13.8899 16.5625 14.0625C16.5625 14.2351 16.7024 14.375 16.875 14.375ZM16.875 14.6875C17.2202 14.6875 17.5 14.4077 17.5 14.0625C17.5 13.7173 17.2202 13.4375 16.875 13.4375C16.5298 13.4375 16.25 13.7173 16.25 14.0625C16.25 14.4077 16.5298 14.6875 16.875 14.6875Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    d: "M6.25 12.5C6.25 12.8452 5.97018 13.125 5.625 13.125C5.27982 13.125 5 12.8452 5 12.5C5 12.1548 5.27982 11.875 5.625 11.875C5.97018 11.875 6.25 12.1548 6.25 12.5Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 12.8125C5.79759 12.8125 5.9375 12.6726 5.9375 12.5C5.9375 12.3274 5.79759 12.1875 5.625 12.1875C5.45241 12.1875 5.3125 12.3274 5.3125 12.5C5.3125 12.6726 5.45241 12.8125 5.625 12.8125ZM5.625 13.125C5.97018 13.125 6.25 12.8452 6.25 12.5C6.25 12.1548 5.97018 11.875 5.625 11.875C5.27982 11.875 5 12.1548 5 12.5C5 12.8452 5.27982 13.125 5.625 13.125Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    d: "M15 12.5C15 12.8452 14.7202 13.125 14.375 13.125C14.0298 13.125 13.75 12.8452 13.75 12.5C13.75 12.1548 14.0298 11.875 14.375 11.875C14.7202 11.875 15 12.1548 15 12.5Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 12.8125C14.5476 12.8125 14.6875 12.6726 14.6875 12.5C14.6875 12.3274 14.5476 12.1875 14.375 12.1875C14.2024 12.1875 14.0625 12.3274 14.0625 12.5C14.0625 12.6726 14.2024 12.8125 14.375 12.8125ZM14.375 13.125C14.7202 13.125 15 12.8452 15 12.5C15 12.1548 14.7202 11.875 14.375 11.875C14.0298 11.875 13.75 12.1548 13.75 12.5C13.75 12.8452 14.0298 13.125 14.375 13.125Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    d: "M10.625 18.125C10.625 18.4702 10.3452 18.75 10 18.75C9.65482 18.75 9.375 18.4702 9.375 18.125C9.375 17.7798 9.65482 17.5 10 17.5C10.3452 17.5 10.625 17.7798 10.625 18.125Z",
    fill: "black"
  }), react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.4375C10.1726 18.4375 10.3125 18.2976 10.3125 18.125C10.3125 17.9524 10.1726 17.8125 10 17.8125C9.82741 17.8125 9.6875 17.9524 9.6875 18.125C9.6875 18.2976 9.82741 18.4375 10 18.4375ZM10 18.75C10.3452 18.75 10.625 18.4702 10.625 18.125C10.625 17.7798 10.3452 17.5 10 17.5C9.65482 17.5 9.375 17.7798 9.375 18.125C9.375 18.4702 9.65482 18.75 10 18.75Z",
    fill: "black"
  }));
};